export default {
  blends: {
    eudrDueDiligence: 'Diligencia Debida EUDR',
    validationMessage:{
      requiredMessage:'Este campo es obligatorio',
      isNumber:'Debe ser un número',
      isValidNumber:'Debe ser un número válido',
      noNegativeNumbers:'No se permiten números negativos',
      atLeastTwoProducts:'Se requieren al menos dos productos',
    },
    exemptProducts: {
      eudrExemptProducts: 'Productos exentos de EUDR',
      addEUDRExemptProduct: 'Agregar producto exento de EUDR',
      updateEUDRExemptProduct: 'Actualizar producto exento de EUDR',
      internalRefNumber: 'Número de referencia interno',
      supplier: 'Proveedor',
      containerID: 'ID del contenedor',
      product: 'Producto',
      quantity: 'Cantidad',
      dateAdded: 'Fecha de agregado',
      addProduct: 'Agregar producto',
      selectDate: 'Seleccionar fecha',
      addContainer: 'Agregar contenedor',
      containerInformation: 'Información del contenedor',
      supplierInformation: 'Información del proveedor',
      supplierInformationTT:
        'Detalles sobre la entidad que proporciona bienes o servicios.',
      supplierTooltip:
        'Seleccione el proveedor de la lista pre-registrada en el sistema.',
      addnewSupplier: 'Agregar nuevo proveedor',
      internalReferenceNumberMustBeAlphanumeric:
        'El número de referencia interno debe ser alfanumérico',
      netMassMustBeValid: 'La masa neta debe ser válida',
      volumeMustBeNumeric: 'El volumen debe ser numérico',
      subProduct: 'Subproducto',
      netMass: 'Masa neta',
      volume: 'Volumen',
      productDetail: 'Detalles del producto',
      placeOfActivity: 'Lugar de actividad',
      countryOfActivity: 'País de actividad',
      countryOfEntry: 'País de entrada',
      activity: 'Actividad',
      internalRefNo: 'Número de referencia interno',
      name: 'Nombre',
      email: 'Correo electrónico',
      phoneNumber: 'Número de teléfono',
      country: 'País',
      status: 'Estado',
      addNewSupplier: 'Agregar un nuevo proveedor',
      availableForBlends: 'Disponible para mezclas',
      thisFieldIsRequired: 'Este campo es obligatorio.',
      enterSupplierFirstName: 'Ingrese el nombre del proveedor',
      enterSupplierLastName: 'Ingrese el apellido del proveedor',
      enterEmailAddress: 'Ingrese la dirección de correo electrónico',
      enterPhoneNumber: 'Ingrese el número de teléfono',
      selectCountry: 'Seleccionar país',
      firstNameIsRequired: 'El nombre es obligatorio',
      lastNameIsRequired: 'El apellido es obligatorio',
      unAvailableForBlends: 'No disponible para mezclas',
      exemptAddedSuccessfully:
        '¡El producto exento de EUDR se ha agregado con éxito!',
      unExpectedErrorMsg:
        'Ocurrió un error inesperado. Por favor intente de nuevo.',
      availabilityStatusMsg:
        'El estado de disponibilidad para mezclas se ha actualizado con éxito.',
      updateProduct: 'Actualizar producto',
      exemptUpdatedSuccessfully:
        '¡El producto exento de EUDR se ha actualizado con éxito!',
      invalidNumericValue: 'Valor numérico inválido',
      containerIDTT:
        'Este es un identificador único del contenedor. Por favor, inserte el ID del contenedor a continuación',
        actions: 'Acciones',
    },
  
    blends: 'Mezclas',
    blendSetting: 'Configuración de Mezcla',
    createBlendDds: 'Crear Blend DDS',
    country: 'País',
    countryTT: 'País',
    select: 'Seleccionar',
    edurDueDeligenceStatus: 'Estado de Diligencia Debida EUDR',
    dueDiligenceStatus: 'Estado de Diligencia Debida',
    EUDRDeforestationStatusTT: 'Estado de Deforestación EUDR',
    dueDeligenceStatus: 'Estado de Diligencia Debida',
    uploadedToEU: 'Subido a la UE',
    pending: 'Pendiente',
    underReview: 'En Revisión',
    compliant: 'Cumple',
    nonCompliant: 'No Cumple',
    processingFarm: 'Procesando Granja',
    analyzingDeforestation: 'Analizando Deforestación',
    writingToBlockchain: 'Escribiendo en Blockchain',
    readyToProceed: 'Listo para Continuar',
    mitigationRequired: 'Mitigación Requerida',
    viewReport: 'Ver Informe',
    share: 'Compartir',
    copyAndCreateNew: 'Copiar y Crear Nuevo',
    remove: 'Eliminar',
    eudrRefNo: 'EUDR/Número de Referencia Interna',
    finalProduct: 'Título de Mezcla y ID de Lote de Mezcla',
    noOfIngredients: 'N.º de Ingredientes',
    farmsAndQuantity: 'Granjas y Cantidad',
    actions: 'Acciones',
    confirmDialog: {
      delete: {
        title: 'Eliminar Mezcla',
        message: '¿Está seguro de que desea eliminar esta Mezcla?',
        confirmBtn: 'Confirmar',
        cancelBtn: 'Cancelar',
      },
    },
    searchBlend: 'Buscar Mezcla por Producto Final',
    blendDuplicatedSuccessfully: 'La mezcla se ha duplicado con éxito.',
    reportDeletedSuccessfully: 'Informe eliminado con éxito.',
  
    blendSettings: {
      dashboard: 'Panel de Control',
      blendSettings: 'Configuración de Mezclas',
      importBlends: 'Importar Mezclas',
      addNewBlend: 'Agregar Nueva Mezcla',
      searchTitle: 'Buscar por Título de Mezcla',
      view: 'Ver',
      edit: 'Editar',
      farms: 'Granjas',
      remove: 'Eliminar',
      blendCode: 'Código de Mezcla',
      blendTitle: 'Título de Mezcla',
      description: 'Descripción',
      'finalProductName&Code': 'Nombre y Código del Producto Final',
      dateAdded: 'Fecha Agregada',
      actions: 'Acciones',
      addBlend: 'Agregar Configuración de Mezcla',
      cancel: 'Cancelar',
      createBlend: 'Crear Mezcla',
      generalData: 'Datos Generales',
      generalDataTT: "Esta etiqueta muestra todos los datos en la pantalla.",
      blendTitleTT: "El menú desplegable se puede acceder haciendo clic en él, lo que revela una lista de mezclas disponibles para seleccionar.",
      enterHere: 'Ingrese aquí',
      blendCodeTT: 'Código de Mezcla',
      blendDescription: 'Descripción de la Mezcla',
      blendDescriptionTT: 'Descripción de la Mezcla',
      finalProductName: 'Nombre del Producto Final',
      finalProductNameTT: 'Nombre del Producto Final',
      finalProductCode: 'Código del Producto Final',
      finalProductCodeTT: 'Código del Producto Final',
      processType: 'Tipo de Proceso',
      processTypeTT: 'Tipo de Proceso',
      finalProductLotIdGen: 'Generador de Lotes del Producto Final de Mezcla',
      finalProductLotIdGenTT: 'Generador de Lotes del Producto Final de Mezcla',
      productDetails: 'Productos de Mezcla (Ingredientes)',
      productDetailsTT: 'Productos de Mezcla (Ingredientes)',
      selectType: 'Seleccionar Tipo',
      startCount: 'Contador Inicial',
      resetCounterEach: 'Reiniciar Contador Cada',
      enter: 'Ingresar',
      staticText: 'Texto Estático',
      incrementalNumber: 'Número Incremental',
      year: 'Año',
      month: 'Mes',
      date: 'Fecha',
      none: 'Ninguno',
      space: 'Espacio',
      '0001': '0001',
      resetCounter: 'Reiniciar contador cada',
      selectSeparator: 'Seleccionar Separador',
      previewLotId: 'Vista Previa del ID de Lote',
      blendProducts: 'Productos de Mezcla',
      blendProductTT: "Agregue varios productos y subproductos de productos exentos de DDS/EUDR para crear una mezcla.",
      product: 'Producto',
      productTT: 'Producto',
      selectProduct: 'Seleccionar Producto',
      subProduct: 'Subproducto',
      subProductTT: 'Subproducto',
      selectSubProduct: 'Seleccionar Subproducto',
      originCountry: 'País de Origen',
      originCountryTT: 'País de Origen',
      selectCountry: 'Seleccionar País',
      percentage: 'Porcentaje',
      percentageTT: 'Porcentaje',
      addAnotherProduct: 'Agregar Otro Producto',
      confirmation: 'Confirmación',
      createBlendMessage: '¿Está seguro de que desea agregar una nueva mezcla?',
      updateBlendMessage: '¿Está seguro de que desea actualizar esta mezcla?',
      confirm: 'Confirmar',
      pleaseFillRequiredFields: 'Por favor complete los campos obligatorios',
      lightRoast: 'Tostado Claro',
      mediumRoast: 'Tostado Medio',
      mediumDarkRoast: 'Tostado Medio-Oscuro',
      darkRoast: 'Tostado Oscuro',
      validation: {
        titleRequired: 'El título es obligatorio',
        codeRequired: 'El código de mezcla es obligatorio',
        descriptionRequired: 'La descripción es obligatoria',
        finalProductNameRequired: 'El nombre del producto final es obligatorio',
        finalProductCodeRequired: 'El código del producto final es obligatorio',
        processTypeRequired: 'El tipo de proceso es obligatorio',
        selectTypeRequired: 'El tipo es obligatorio',
        startCountRequired: 'El contador inicial es obligatorio',
        selectSeparatorRequired: 'El separador es obligatorio',
        finalProductLotIdGenRequired:
          'La generación del ID de lote del producto final es obligatoria',
        productRequired: 'El producto es obligatorio',
        subProductRequired: 'El subproducto es obligatorio',
        originCountryRequired: 'El país de origen es obligatorio',
        percentageRequired: 'El porcentaje es obligatorio',
        hundredPrecent: 'El porcentaje total debe sumar exactamente el 100%',
        productSubproductDuplicatedMsg:
          'El producto y el subproducto están duplicados',
      },
      mustSelectIncrementalNumber: 'Se requiere al menos un número incremental',
      blendSettingsCreated: 'La configuración de mezcla se ha creado con éxito.',
      blendSettingsNotCreated:
        'La creación de la configuración de mezcla no tuvo éxito. Intente nuevamente con datos correctos.',
      confirmDiaglog: {
        delete: {
          title: 'Eliminar',
          message:
            '¿Está seguro de que desea eliminar esta configuración de mezcla?',
          confirmBtn: 'Confirmar',
          cancelBtn: 'Cancelar',
        },
      },
      itemDeletedSuccessfully: 'La configuración de mezcla se eliminó con éxito',
      updateBlend: 'Actualizar Configuración de Mezcla',
      save: 'Guardar',
      blendSettingsUpdated:
        'La configuración de mezcla se ha actualizado con éxito.',
      blendSettingsNotUpdated:
        'La actualización de la configuración de mezcla no tuvo éxito. Intente nuevamente con datos correctos.',
      updateMessage: '¿Está seguro de que desea actualizar esta mezcla?',
      createMessage: '¿Está seguro de que desea agregar una nueva mezcla?',
      finalProductCodeAlreadyExists: 'El código del producto final ya existe',
      blendCodeAlreadyExists: 'El código de mezcla ya existe.',
      valueMustBeNumber: 'Este campo debe ser un número',
      valueMustBeNonNegative: 'Este campo debe ser mayor que cero',
    },
  
    imports: {
      imports: 'Importaciones',
      blends: 'Mezclas',
      createNewImport: 'Crear Nueva Importación',
      importsBlends: 'Importaciones de Mezclas',
      createBlends: 'Crear Mezclas',
      downloadTemplateInfo:
        'Descargue y utilice las plantillas a continuación para importar geocercas en bloque.',
      selectTemplate: 'Seleccionar Plantilla',
      downloadXlsTemplate: 'Descargar Formato de Plantilla de Importación XLS',
      downloadProductCodes: 'Descargar Códigos de Producto',
      selectFileToUpload: 'Seleccionar archivo para cargar datos',
      orDragDrop: 'O arrastre y suelte archivos aquí',
      removeFile: 'Eliminar Archivo',
      importantNote: 'Nota Importante',
      templateNote:
        'Por favor, use las plantillas proporcionadas anteriormente para cargas masivas. Otros formatos resultarán en fallos.',
      importData:'Asegúrese de que estos datos no se conserven hasta que todos los estados sean exitosos.',
      fileUploadSuccess: 'Archivo cargado con éxito',
      invalidFileFormat:
        'Formato de archivo inválido. Por favor cargue un archivo válido',
      pleaseSelectSource: 'Por favor seleccione al menos una fuente',
      blendTitle: 'Título de Mezcla',
      blendCode: 'Código de Mezcla',
      finalProductCode: 'Código del Producto Final',
      finalProductName: 'Nombre del Producto Final',
      status: 'Estado',
      downloadCsvTemplate: 'Descargar Formato de Plantilla de Importación CSV',
      dropHere: 'o arrastre y suelte aquí',
      Importing: 'Importando...',
      modalMessage:
        'Su archivo cargado está siendo procesado. Le notificaremos una vez que el archivo haya sido cargado con éxito.',
      importXLSFormat: 'Importar Formato XLS',
      importCSVFormat: 'Importar Formato CSV',
      fileSelected: 'El archivo ha sido seleccionado con éxito.',
      success: 'Los datos han sido importados con éxito.',
      importCompleted: 'Importación Completada',
      invalidHeaders: "Encabezados de archivo inválidos",
      headerMismatchErro: "El archivo cargado debe contener los siguientes encabezados",
      missingHeaders: "Encabezados faltantes",
      additionalHeaders: "Encabezados adicionales (no permitidos)"
    },
  
    history: {
      history: 'Historial',
      fileName: 'Nombre del Archivo',
      importedOn: 'Importado En',
      status: 'Estado',
      action: 'Acción',
      blends: 'Mezclas',
      download: 'Descargar',
      success: 'Éxito',
      failed: 'Fallido'
    },
  
    createBlends: {
      blendProductTT: 'Agregue varios productos y subproductos de DDS/Productos Exentos EUDR para crear una mezcla',
      eudrDueDiligence: 'Diligencia Debida EUDR',
      createBlends: 'Crear Mezclas',
      discard: 'Descartar',
      reject: 'Rechazar',
      saveAndContinueLater: 'Guardar y Continuar Después',
      generateReport: 'Generar Informe',
      generalData: 'Datos Generales',
      blend: 'Mezcla',
      selectBlend: 'Seleccionar Mezcla',
      blendCode: 'Código de Mezcla',
      blendDescription: 'Descripción de Mezcla',
      finalProduct: 'Producto Final',
      finalProductCode: 'Código de Producto Final',
      netMass: 'Masa Neta',
      netMassTT: "Permite a los usuarios ingresar el valor del impuesto sobre la masa neta asociado con un producto, envío o transacción.",
      volume: 'Volumen',
      volumeTT: "La etiqueta se muestra de manera destacada junto a un campo o sección donde se presentan o ingresan datos relacionados con el volumen, como en las especificaciones de productos o formularios de envío.",
      blendLotId: 'ID de Lote de Mezcla',
      blendLotIdTT: "Muestra el identificador único del lote según la configuración de Blend para rastrear el lote de mezcla.",
      finishedProductLotId: 'ID de Lote de Producto Terminado',
      finishedProductLotIdTT: "Ingrese el identificador único del lote para rastrear el lote final del producto.",
      enterHere: 'Introducir Aquí',
      internalReferenceNumber: 'Número de Referencia Interna',
      internalReferenceNumberTT: "Código de referencia interno para fines de seguimiento.",
      eudrReferenceNumber: 'Número de Referencia EUDR',
      eudrReferenceNumberTT: "Código de referencia de cumplimiento de la EUDR (Regulación de Deforestación de la Unión Europea). Esto se completará automáticamente si el usuario desea subirlo a la EUDR después de crear el informe.",
      companyId: 'ID de la Empresa',
      companyIdTT: "Identificador de la empresa asociada con esta mezcla.",
      activity: 'Actividad',
      domestic: 'Doméstico',
      import: 'Importación',
      export: 'Exportación',
      containerInformation: 'Información del Contenedor',
      containerInformationTT: "Este es un identificador único del contenedor. Por favor, inserte el ID del contenedor a continuación.",
      addContainer: 'Añadir Contenedor',
      blendProduct: 'Producto de Mezcla',
      product: 'Producto',
      productTT: "Muestra a los usuarios el producto seleccionado de una lista de productos disponibles en la configuración de mezcla para su procesamiento, análisis o generación de informes dentro de la aplicación, facilitando la entrada y gestión precisa de datos.",
      subProduct: 'Subproducto',
      subProductTT: "Muestra a los usuarios los subproductos seleccionados de los disponibles en la configuración de mezcla relacionados con un producto principal seleccionado, facilitando la entrada y gestión detallada de datos dentro de la aplicación.",
      ddsId: 'ID DDS',
      containerId: 'ID del Contenedor',
      uniqueContainerId:"El ID del contenedor debe ser único",
      containerIdTT: "Identificador único para el contenedor que transporta esta mezcla.",
      country: 'País',
      countryTT: "Elija el país asociado con el origen o destino de la mezcla.",
      search: 'Buscar',
      select: 'Seleccionar',
      addAnotherProduct: 'Añadir Otro Producto',
      customization: 'Personalización',
      recordsPerPage: 'Registros por página',
      restoreDefault: 'Restaurar Predeterminado',
      apply: 'Aplicar',
      applyFilter:"Aplicar filtro",
      clearFilter:"Limpiar filtro",
      status: {
        compliant: 'Cumple',
        nonCompliant: 'No Cumple',
        uploadToEudr:"CARGADO AL PORTAL DE LA UE",
        eudrExempt: "EXENTO DE EUDR",
      },
      table: {
        eudrInternalRef: 'EUDR / Número de Referencia Interna',
        containerId: 'ID del Contenedor',
        product: 'Producto',
        farmsQuantity: 'Granjas y Cantidad',
        submissionDate: 'Fecha de Envío',
        dueDiligenceStatus: 'Estado de Diligencia Debida',
        availabilityForBlends: 'Disponibilidad para Mezclas',
        pleaseSelectSource: 'Por favor, seleccione al menos una fuente',
      },
      productionPlaceTable: {
        productionPlaceAndFarmId: 'Lugar de Producción y ID de la Granja',
        product: 'Producto',
        producerName: 'Nombre del Productor',
        addressOfProduction: 'Dirección de Producción',
        status: 'Estado de Deforestación EUDR',
        riskAssessment: 'Evaluación de Riesgo',
      },
      
      addNewSupplier: 'Añadir un Nuevo Proveedor',
      addNewBlend: 'Añadir Nueva Mezcla',
      placeOfActivity: 'Lugar de Actividad del Operador',
      placeOfActivityTT: "Especifique el país del operador donde se realizan las actividades y el país donde el producto ingresa al mercado de la UE. Estos detalles son esenciales para garantizar el cumplimiento de los requisitos de EUDR.",
      countryOfActivity: 'País de Actividad del Operador',      
      countryOfActivityTT: "Seleccione el país donde se realiza esta actividad.",
      countryOfEntry: 'País de Entrada',
      countryOfEntryTT: "Seleccione el país de entrada para los productos importados.",
      pleaseSelectAtLeastOne: 'Por favor, seleccione al menos un informe de cada producto',
      blendCreatedSuccessfully: "El blend se ha creado con éxito.",
      blendCreateFailed: "Ocurrió un error al crear el blend.",
      blendUpdatedSuccessfully: "El blend se ha actualizado con éxito.",
      blendUpdateFailed: "Ocurrió un error al actualizar el blend.",
      blendDeletedSuccessfully: "El blend se ha eliminado con éxito.",
      blendSavedSuccessfully: 'El blend se ha guardado con éxito.',
      blendUploadedToEUSuccessfully: "El blend se ha cargado con éxito en la UE.",
    },
  
    manageProducts: {
      addNewProduct: 'Agregar Nuevo Producto',
      editProduct: 'Editar Producto',
      addNewSubProduct: 'Agregar Nuevo Subproducto',
      editSubProduct: 'Editar Subproducto',
      productTitle: 'Título del Producto',
      subProductTitle: 'Título del Subproducto',
      typeTitle: 'Escriba el título',
      hsCode: 'Código HS',
      typeHSCode: 'Escriba el código HS',
      eudrDocumentCode: 'Código de Documento EUDR',
      selectEudrDocumentCode: 'Seleccione el Código de Documento EUDR',
      makeSelection: 'Hacer una selección',
      uploadCategoryImage: 'Subir Imagen de Categoría',
      addImage: 'Añadir Imagen',
      cancel: 'Cancelar',
      save: 'Guardar',
      back: 'Atrás',
      add: 'Agregar',
      confirm: 'Confirmar',
      deleteMessage: '¿Está seguro de que desea eliminar',
      invalidFileType: 'Tipo de archivo inválido',
      errorUploadingFile:
        'Ocurrió un error inesperado al subir el archivo. Por favor, intente nuevamente más tarde.',
      fileUploadFailed: 'Falló la Carga del Archivo',
      selectDocumentCode: 'Seleccione Código de Documento',
      view: 'Ver',
      edit: 'Editar',
      remove: 'Eliminar',
      search: 'Buscar',
      searchByProductName: 'Buscar por Nombre de Producto',
      eudrDueDiligence: 'Diligencia Debida EUDR',
      products: 'Productos',
      subProducts: 'Subproductos',
      fieldRequired: 'Este campo es obligatorio',
      fileRequired: 'Archivo Requerido',
      fileRequiredMessage:
        'Por favor, suba o seleccione un archivo antes de guardar el producto.',
      addNewDocumentCode: 'Agregar Nuevo Código de Documento',
      enterHere: 'Introducir aquí',
      documentCode: 'Código de Documento',
      title: 'Título',
      description: 'Descripción',
      updateProduct: 'Actualizar Producto',
      updateSubProduct: 'Actualizar Subproducto',
      deleteSubProduct: 'Eliminar Subproducto',
      deleteProduct: 'Eliminar Producto',
      productAddedMessage: 'El producto ha sido agregado exitosamente.',
      subProductAddedMessage: 'El subproducto ha sido agregado exitosamente.',
      productUpdateMessage: 'El producto ha sido actualizado exitosamente.',
      subProductUpdateMessage: 'El subproducto ha sido actualizado exitosamente.',
      subProductDeleteMessage: 'El subproducto ha sido eliminado exitosamente.',
      productDeleteMessage: 'El producto ha sido eliminado exitosamente.',
      pleaseTryAgain: 'Algo salió mal. Por favor, intente nuevamente más tarde.',
      documentCodeDuplicate: 'El código de documento ya existe',
      unsupportedFileFormat: 'Tipo de archivo no compatible. Por favor, sube un archivo de imagen válido.',
      tableHeaders: {
        productName: 'Nombre del Producto',
        hsCode: 'Código HS',
        eudrDocumentCode: 'Código de Documento EUDR',
        subProduct: 'Subproductos',
        dateAdded: 'Fecha de Adición',
        action: 'Acciones',
      },
      documentCodeSaved: 'El código de documento ha sido guardado exitosamente.',
    },
  
    finalReport: {
      title: 'Informe Final de Mezclas',
      reportStatus: 'Estado del Informe',
      blendTitle: 'Título de la Mezcla',
      blendCode: 'Código de la Mezcla',
      finalProduct: 'Producto Final',
      finalProductCode: 'Código del Producto Final',
      blendDescription: 'Descripción de la Mezcla',
      processType: 'Tipo de Proceso',
      netMass: 'Masa Neta',
      volume: 'Volumen',
      blendLotId: 'ID de Lote de Mezcla',
      finalProductLotId: 'ID de Lote de Producto Final',
      internalReferenceNumber: 'Número de Referencia Interna',
      eudrReferenceNumber: 'Número de Referencia EUDR',
      activity: 'Actividad',
      countryOfActivity: 'País de Actividad',
      countryOfEntry: 'País de Entrada',
      dueDiligenceReportStatus: 'Estado del Informe de Diligencia Debida',
      containerId: 'ID de Contenedor',
      operatorData: 'Datos del Operador',
      name: 'Nombre',
      country: 'País',
      isoCode: 'Código ISO',
      eoriNumber: 'Número EORI',
      reportSummary: {
        title: 'Resumen del Informe',
        totalDdsReports: 'Total de Informes DDS',
        totalGeofencePolygons: 'Total de Polígonos de Geovallas',
        totalGeofencePoints: 'Total de Puntos de Geovalla',
        totalDeforestationAssessments: 'Total de Evaluaciones de Deforestación',
        totalRiskAssessments: 'Total de Evaluaciones de Riesgo',
        totalFarms: 'Total de Granjas',
        totalHighDeforestationFarms: 'Total de Granjas de Alta Deforestación',
        totalLowZeroRiskFarms: 'Total de Granjas de Bajo y Cero Riesgo',
        totalArea: 'Área Total (ha)',
        averageGeofenceArea: 'Área Promedio de Geovalla (ha)',
        totalHighRiskFarmArea: 'Área Total de Granjas de Alto Riesgo',
        totalLowZeroRiskFarmArea: 'Área Total de Granjas de Bajo y Cero Riesgo',
        productionPlaces: 'Lugares de Producción',
        productionPlacesTooltip: 'Detalles sobre los lugares de producción',
        declarationStatement: 'Declaración del Operador',
        declarationStatementTooltip: 'Declaración oficial del operador',
        declarationText1:
          '[Nombre] {name}, por la presente declaro que todos los datos enviados con este envío son precisos según mi mejor conocimiento y creencia.',
        declarationText2:
          'Yo, [Nombre] {name}, afirmo que he visitado las granjas asociadas con este envío y confirmo su cumplimiento con las leyes y regulaciones locales sobre la deforestación.',
      },
      blendProducts: {
        title: 'Productos de la Mezcla',
        product: 'Producto',
        subProduct: 'Subproducto',
        country: 'País',
        reference: 'Referencia EUDR / Interna',
        containerId: 'ID de Contenedor',
        farmsQuantity: 'Granjas & Cantidad',
        submissionDate: 'Fecha de Envío',
        status: 'Estado',
      },
      activityLog: {
        title: 'Registro de Actividad',
        user: 'Usuario',
        userRole: 'Rol del Usuario',
        ipAddress: 'Dirección IP',
        dateTime: 'Fecha y Hora',
        segment: 'Segmento',
        activityDescription: 'Descripción de la Actividad',
      },
      declaration: {
        title: 'Declaración del Operador',
        name: 'Nombre',
        address: 'Dirección',
        dateTime: 'Fecha y Hora',
      },
      buttons: {
        update: 'Actualizar',
        discard: 'Descartar',
        reject: 'Rechazar',
        edit: 'Editar',
        finalize: 'Finalizar',
        download: 'Descargar',
        uploadToEuPortal: 'Subir al Portal de la UE',
        submit: 'Enviar',
      },
    },
  }
};